/**
 * Time: 2020-07-27 10:29:57
 * Author: zyl
 * Description: 图片编辑器 替代 editPictureModule
*/
'use strict';
angular.module('imgEditorCanvasModule', []).controller('editImgCtrl', ['$scope', '$element', 'dlgOption', '$modalInstance', '$q', '$timeout', '$state', 'imgEditorCanvasBaseService', 'editPictureService', 'trsHttpService', 'modalDialog', 'publicToolService', function ($scope, $element, dlgOption, $modalInstance, $q, $timeout, $state, imgEditorCanvasBaseService, editPictureService, trsHttpService, modalDialog, publicToolService) {
    $scope.showLoading = true; // 展开弹窗loading

    $scope.cropperOption = dlgOption.cropperOption || {};

    var imgUrl = dlgOption.image.PERPICURL; // '/wcm/file/read_image.jsp?FileName=U020200722572564937414.jpg'

    // 处理图片路径 搬自天目云 ------------------ 开始 ---------------------------------------------
    // if (imgUrl.indexOf("ScaleWidth=600") >= 0) {
    //     imgUrl = imgUrl.replace(/ScaleWidth=600&/g, "");
    // }
    // if (imgUrl.indexOf("http") === 0) {   // 移除 origin
    //     var prepicurlArray = imgUrl.split("/").splice(3);
    //     imgUrl = ("/" + prepicurlArray.join("/")).replace(/_600\./g, ".").replace(/\/\//g, "/"); //兼容后端bug，双斜杠改为单斜杠
    // }
    var curRouterName = $state.current.name.split('.').pop();
    // 处理图片路径 搬自天目云 ------------------ 结束 ------------------------------------------

    $scope.imgUrl = imgUrl;

    $scope.status = {
        APPFILE: dlgOption.image.APPFILE, // 图片名称 'U020200722572564937414.jpg'
    };
    if (curRouterName.indexOf('fusion') === -1) { // iwo渠道没有水印
        $scope.status.siteId = dlgOption.siteId;
        $scope.status.channelId = dlgOption.channelId;
        $scope.status.productId = publicToolService.getNewmediaTypeAndProductId().productId;
        // 类型
        $scope.status.mediaType = publicToolService.getNewmediaTypeAndProductId().mediaType;
    }

    /** ******************** base begin **********************/
    var $editImage = $element.find('#edit_image'),
        DEFAULT = { // cropper初始化选项
            viewMode: 1,
            modal: false,
            highlight: false,
            autoCropArea: 0.98,
        },
        imageType = 'image/jpeg',
        extendOptions = {
            toggleDragModeOnDblclick: true,
            autoCrop: true,
            dragMode: 'crop',
            built: function () {

                $scope.applying = false;
                $scope.info.setImageSize();
                updateCanvas();
                safeApply();

            }
        }, // 针对每个不同功能项的补充参数
        imageCache = (function () {// 图片记录

            var ImageCache = function () {
                var self = this;
                self.list = [];
                self.activeItem = '';
                self.active = -1;
            };
            ImageCache.prototype = {
                push: function (urlData) {
                    var t = this;
                    t.active = t.active + 1;
                    t.list.splice(t.active, 0, urlData);
                    t.activeItem = t.list[t.active];
                },
                setActiveItem: function (index) {

                    var t = this,
                        len = t.list.length;

                    if (index < len && index > -1) {
                        t.active = index;
                        t.activeItem = t.list[index];
                    }

                },
                getActiveItem: function (type) {
                    // type:back,next
                    var t = this,
                        len = t.list.length;

                    if (type == 'back' && t.active > 0) {
                        // 向前
                        t.active = t.active - 1;
                        t.activeItem = t.list[t.active];
                    }
                    if (type == 'next' && t.active < len - 1) {
                        // 向后
                        t.active = t.active + 1;
                        t.activeItem = t.list[t.active];
                    }
                    return t.activeItem;

                },
                clear: function (init) {
                    var t = this;
                    if (init) {
                        t.active = 0;
                        t.list = [t.list[t.active]];
                        t.activeItem = t.list[t.active];
                    } else {
                        t.list = [];
                        t.activeItem = '';
                        t.active = -1;
                    }
                }
            };

            return new ImageCache();

        })();

    $scope.imageCache = imageCache;


    // 模块根目录
    $scope.baseUrl = './components/directive/imgEditorCanvas';
    // 模板
    $scope.tmpLeftSource = {
        crop: $scope.baseUrl + '/left/crop_tpl.html',
        rotate: $scope.baseUrl + '/left/rotate_tpl.html',
        size: $scope.baseUrl + '/left/size_tpl.html',
        text: $scope.baseUrl + '/left/text_tpl.html',
        quality: $scope.baseUrl + '/left/quality_tpl.html',
        watermark: $scope.baseUrl + '/left/watermark_tpl.html',
        scrawl: $scope.baseUrl + '/left/scrawl_tpl.html'
    };
    $scope.tmpLeft = $scope.tmpLeftSource.crop;
    $scope.applying = false;
    // 导航
    $scope.nav = (function () {
        var RetClass = function () {
            var self = this;
            // 功能列表选中项索引
            self.checked = 0;
            self.isBackOrForward = false;// 是否未完成向前或向后操作
            // 功能列表
            var functionList = [
                {
                    name: '裁剪',
                    alias: 'crop',
                    icon: 'icon-caijian'
                }, {
                    name: '旋转',
                    alias: 'rotate',
                    icon: 'icon-xuanzhuan'
                }, {
                    name: '缩放',
                    alias: 'size',
                    icon: 'icon-suofang'
                }, {
                    name: '文字',
                    alias: 'text',
                    icon: 'icon-wenzi123'
                }, {
                    name: '品质',
                    alias: 'quality',
                    icon: 'icon-quality'
                }, {
                    name: '水印',
                    alias: 'watermark',
                    icon: 'icon-shuiyinguanli'
                }, {
                    name: '涂鸦',
                    alias: 'scrawl',
                    icon: 'icon-tuya'
                }
            ];

            if ($scope.cropperOption.size) {
                functionList.splice(2, 1);
            }

            if (!$scope.status.siteId && !$scope.status.channelId && !$scope.status.productId) { // 隐藏水印
                functionList.splice(5, 1);
            }

            self.functionList = functionList;

            // 操作列表
            self.operationList = [
                {
                    name: '一键还原',
                    alias: 'restore'
                }, {
                    name: '放大',
                    alias: 'zoom_in'
                }, {
                    name: '缩小',
                    alias: 'zoom_out'
                }, {
                    name: '向前',
                    alias: 'back'
                }, {
                    name: '向后',
                    alias: 'forward'
                }
            ];

            self.leftHover = null;
            self.rightHover = null;
        };
        RetClass.prototype = {
            switch: function (alias, index) {
                var t = this;
                if (t.checked === index) {return;}
                $scope.watermark.selectedWaterMark = null;
                $scope.watermark.clearCanvas();
                $scope.size.resetPre();
                $scope.size.isEdit = false; // 切换tap页时，自动将缩放页的改动标识置为false
                switch (alias) {
                    case 'crop':
                        // 裁剪
                        $scope.tmpLeft = $scope.tmpLeftSource.crop;
                        extendOptions = {
                            toggleDragModeOnDblclick: true,
                            autoCrop: true,
                            dragMode: 'crop',
                            modal: true,
                            built: function () {

                                $scope.applying = false;
                                $scope.info.setImageSize();
                                // updateCanvas();
                                safeApply();
                                deleteContainer();
                                $timeout(function() {
                                    if ($scope.cropperOption.size) {
                                        $scope.preScale.switch(0);
                                    } else {
                                        updateCanvas();
                                    }
                                });
                            }
                        };
                        t.updateCropper(extendOptions);
                        break;
                    case 'rotate':
                        // 旋转
                        $scope.tmpLeft = $scope.tmpLeftSource.rotate;
                        extendOptions = {
                            toggleDragModeOnDblclick: false,
                            autoCrop: false,
                            dragMode: 'move',
                            built: function () {

                                $scope.applying = false;
                                $scope.info.setImageSize();
                                updateCanvas();
                                safeApply();
                                deleteContainer();

                            }
                        };
                        t.updateCropper(extendOptions);
                        break;
                    case 'size':
                        // 尺寸
                        $scope.tmpLeft = $scope.tmpLeftSource.size;
                        extendOptions = {
                            toggleDragModeOnDblclick: false,
                            autoCrop: false,
                            dragMode: 'move',
                            built: function () {
                                $scope.size.initWAH().setCanvasData($scope.size.width, $scope.size.height);

                                $scope.applying = false;
                                $scope.info.setImageSize();
                                updateCanvas();
                                safeApply();
                                deleteContainer();
                            }
                        };
                        t.updateCropper(extendOptions);
                        break;
                    case 'text':
                        // 文字
                        $scope.tmpLeft = $scope.tmpLeftSource.text;
                        extendOptions = {
                            toggleDragModeOnDblclick: false,
                            autoCrop: false,
                            dragMode: 'move',
                            built: function () {

                                // $textBody = $('.left-text .left-body');
                                $scope.text.initTextEdit();

                                $scope.applying = false;
                                $scope.info.setImageSize();
                                updateCanvas();
                                safeApply();
                                deleteContainer();

                            }
                        };
                        t.updateCropper(extendOptions);
                        break;
                    case 'quality':
                        // 品质
                        $scope.tmpLeft = $scope.tmpLeftSource.quality;
                        $scope.quality.value = 100;
                        extendOptions = {
                            toggleDragModeOnDblclick: false,
                            autoCrop: false,
                            dragMode: 'move',
                            built: function () {

                                $scope.applying = false;
                                $scope.info.setImageSize();
                                updateCanvas();
                                safeApply();
                                deleteContainer();

                            }
                        };
                        t.updateCropper(extendOptions);
                        break;
                    case 'watermark':
                        // 水印
                        $scope.tmpLeft = $scope.tmpLeftSource.watermark;
                        $scope.watermark.init();
                        extendOptions = {
                            toggleDragModeOnDblclick: false,
                            autoCrop: false,
                            dragMode: 'move',
                            zoomable: false,
                            built: function () {

                                $scope.applying = false;
                                $scope.info.setImageSize();
                                updateCanvas();
                                // $scope.watermark.resetImage();
                                $scope.watermark.changeWaterMark(0);
                                safeApply();
                                deleteContainer();

                            }
                            // zoom: function () {
                            //     $scope.watermark.resetImage();
                            //     safeApply();

                            // }
                        };
                        t.updateCropper(extendOptions);
                        break;
                    case 'scrawl':
                        // 涂鸦
                        $scope.tmpLeft = $scope.tmpLeftSource.scrawl;
                        extendOptions = {
                            toggleDragModeOnDblclick: false,
                            autoCrop: false,
                            dragMode: 'none',
                            zoomable: false,
                            built: function () {

                                $scope.scrawl.init();
                                $scope.applying = false;
                                $scope.info.setImageSize();
                                updateCanvas();
                                safeApply();
                                deleteContainer();

                            }
                        };
                        t.updateCropper(extendOptions);
                        break;
                }
                t.checked = index;

            },
            updateCropper: function (opt) {
                var url = imageCache.activeItem,
                    options = angular.extend({}, DEFAULT, opt);

                $editImage.one('load', function () {
                    $editImage.cropper('destroy').cropper(options);
                });
                $editImage.attr('src', url);
            },
            operation: function (index) {
                var t = this;
                switch (index) {
                    case 0:
                        // 一键还原
                        var url = imageCache.list[0],
                            options = angular.extend({}, DEFAULT, extendOptions);

                        $editImage.one('load', function () {
                            $editImage.cropper('destroy').cropper(options);
                            imageCache.setActiveItem(0);
                            imageCache.clear(true);
                        });
                        $editImage.attr('src', url);
                        break;
                    case 1:
                        // 放大
                        $editImage.cropper('zoom', 0.1);
                        break;
                    case 2:
                        // 缩小
                        $editImage.cropper('zoom', -0.1);
                        break;
                    case 3:
                        // 返回
                        if (!t.isBackOrForward) {
                            var dataUrl,
                                options = angular.extend({}, DEFAULT, extendOptions),
                                len = imageCache.list.length,
                                active = imageCache.active;

                            if (len > 1 && active > 0) {
                                t.isBackOrForward = true;
                                dataUrl = imageCache.getActiveItem('back');
                                $editImage.one('load', function () {
                                    $editImage.cropper('destroy').cropper(options);
                                    $scope.size.initWAH();
                                    t.isBackOrForward = false;
                                });
                                $editImage.attr('src', dataUrl);
                            }
                        }
                        break;
                    case 4:
                        // 向前
                        if (!t.isBackOrForward) {
                            var dataUrl,
                                options = angular.extend({}, DEFAULT, extendOptions),
                                len = imageCache.list.length,
                                active = imageCache.active;

                            if (len > 1 && active < len - 1) {
                                t.isBackOrForward = true;
                                dataUrl = imageCache.getActiveItem('next');
                                $editImage.one('load', function () {
                                    $editImage.cropper('destroy').cropper(options);
                                    $scope.size.initWAH();
                                    t.isBackOrForward = false;
                                });
                                $editImage.attr('src', dataUrl);
                            }
                        }
                        break;
                }
            },
            setDragMode: function (type) {
                // type:'none', 'crop', 'move'
                $editImage.cropper('setDragMode', type);
            },
            reset: function () {
                var t = this;
                t.switch('crop', 0);
            },
            // 自动保存
            autoSave: function(alias, index) {
                var t = this;
                if (this.checked !== index) {
                    $scope.applyCrop(() => {
                        $timeout(function() {
                            t.switch(alias, index);
                        });
                    });
                }
            }
        };
        return new RetClass();
    })();

    /**
     * [applyCrop description]应用
     *
     * @param  {[type]}  callback   [callback description] 回调函数，用于先保存后切换
     *
     * @return  {[type]}   [return description]
     */
    $scope.applyCrop = function (callback) {
        var croppedCanvas = $editImage.cropper('getCroppedCanvas'), dataURL;

        if ($scope.applying ||
            !croppedCanvas.toDataURL ||
            ($scope.tmpLeft === $scope.tmpLeftSource.crop && croppedCanvas.width < 50)) {
            return;
        }
        dataURL = croppedCanvas.toDataURL(imageType);
        $scope.applying = true;
        if ($scope.tmpLeft === $scope.tmpLeftSource.size) {
            if ($scope.size.isEdit) {
                updateCropperCanvas($scope.size.getUrl());
            } else {
                $scope.applying = false;
                callback && callback();
            }
        } else if ($scope.tmpLeft === $scope.tmpLeftSource.text) {
            $scope.text.save(dataURL).then(function (newDataURL) {
                updateCropperCanvas(newDataURL);
            });
        } else if ($scope.tmpLeft === $scope.tmpLeftSource.quality) {
            $scope.quality.use(dataURL).then(function (newDataURL) {
                updateCropperCanvas(newDataURL);
            });
        } else if ($scope.tmpLeft === $scope.tmpLeftSource.watermark) {
            if ($scope.watermark.selectedWaterMark.url) {
                $scope.watermark.apply(dataURL).then(function (newDataURL) {
                    updateCropperCanvas(newDataURL);
                });
            } else {
                $scope.applying = false;
                callback && callback();
            }
        } else if ($scope.tmpLeft === $scope.tmpLeftSource.scrawl) {
            $scope.scrawl.save(dataURL).then(function (newDataURL) {
                updateCropperCanvas(newDataURL);
            });
        } else {
            updateCropperCanvas(dataURL);
        }

        /**
         * [updateCropperCanvas description]功能： 更新裁剪画布
         *
         * @param  {[type]}  dataURL   [dataURL description]
         *
         * @return  {[type]}   [return description]
         */
        function updateCropperCanvas(dataURL) {

            var options = angular.extend({}, DEFAULT, extendOptions);

            $editImage.one('load', function () {
                $editImage.cropper('destroy').cropper(options);
                if ($scope.size.needTtriggerApply && $scope.tmpLeft == $scope.tmpLeftSource.size) {
                    $scope.size.needTtriggerApply = false;
                    $scope.applyCrop();
                } else {
                    $scope.size.needTtriggerApply = true;
                    imageCache.push(dataURL);
                }
                callback && callback();
            });

            $editImage.attr('src', dataURL);
            $scope.applying = false;

        }

    };

    /** ******************** base end **********************/

    /** ******************** 裁剪begin **********************/
    // 裁剪左栏信息
    $scope.crop = (function (scope) {

        var Crop = function () {
            var self = this;
            self.width = '';
            self.height = '';
        };
        Crop.prototype = {
            updateWAH: function () {
                var t = this;
                t.width = Math.round($scope.info.cropBox.width) || 0;
                t.height = Math.round($scope.info.cropBox.height) || 0;
            },
            validValue: function (e, type) {

                var t = this,
                    key = e.key;

                // console.log($editImage.cropper("getCanvasData"));
                if (!imgEditorCanvasBaseService.isNumber(key)) {
                    t[type] = t[type].replace(/\D/g, '');
                }
            },
            heightToWidth: function () {
                var t = this,
                    ratio = $scope.info.image.aspectRatio;

                if (!imgEditorCanvasBaseService.isNumber(t.height)) {t.height = Math.round($scope.info.cropBox.height);}
                if ($scope.restrainScale.is) {t.width = Math.round(Number(t.height * ratio));}
            },
            widthToHeight: function () {
                var t = this,
                    ratio = $scope.info.image.aspectRatio;
                if (!imgEditorCanvasBaseService.isNumber(t.width)) {t.width = Math.round($scope.info.cropBox.width);}
                if ($scope.restrainScale.is) {t.height = Math.round(Number(t.width / ratio));}
            },
            blurWOH: function (e, type) {
                var t = this;
                if (type == 'width') {t.widthToHeight();}
                if ($scope.restrainScale.is && type == 'height') {t.heightToWidth();}
                $scope.info.setCropBoxData({
                    width: Number(t.width),
                    height: Number(t.height)
                });
            }
        };

        return new Crop();

    })($scope);
    // 约束比例
    $scope.restrainScale = {
        is: false,
        switch: function () {
            var t = this;
            t.is = !t.is;
            if (t.is) {
                $editImage.cropper('setAspectRatio', NaN);
                $scope.info.setCropBoxData({
                    width: Number($scope.crop.width),
                    height: Number($scope.crop.height)
                });
                $scope.preScale.checked = -1;
            }
            $scope.customScale.clear();
        },
        reset: function () {

            var t = this;
            t.is = false;

        }
    };
    // 预设比例
    $scope.preScale = (function (scope) {

        var RetClass = function () {

            var self = this;

            if ($scope.cropperOption.size) { // 如果传入系统比例，则不在允许设置其他比例
                self.list = [$scope.cropperOption.size.split(',').join('：')];
            } else {
                self.list = ['1：1', '2：1', '1：2', '4：3', '3：4', '16：9'];
            }
            self.checked = -1;

        };
        RetClass.prototype = {
            switch: function (index) {
                var t = this,
                    arr = [],
                    aspectRatio = NaN;
                if (index === t.checked && !$scope.cropperOption.size) {
                    t.checked = -1;
                } else {
                    t.checked = index;
                    arr = t.list[index].split('：');
                    aspectRatio = arr[0] / arr[1];
                    $scope.restrainScale.is = false;
                }
                $editImage.cropper('setAspectRatio', aspectRatio);
                $scope.customScale.clear();
                updateCanvas();
            },
            reset: function () {
                var t = this;
                t.checked = -1;
            }
        };

        return new RetClass();

    })($scope);
    // 自定义比例
    $scope.customScale = (function (scope) {
        var RetClass = function () {
            var self = this;
            self.left = '';
            self.right = '';
        };
        RetClass.prototype = {
            clear: function () {
                var t = this;
                t.left = '';
                t.right = '';
            },
            blurLOR: function (type) {
                var t = this;
                if (type == 'l' && !imgEditorCanvasBaseService.isNumber(t.left)) {
                    t.left = '';
                    return;
                }
                if (type == 'r' && !imgEditorCanvasBaseService.isNumber(t.right)) {
                    t.right = '';
                    return;
                }
                if (t.left != '' && t.right != '') {
                    $editImage.cropper('setAspectRatio', t.left / t.right);
                    $scope.preScale.checked = -1;
                    $scope.restrainScale.is = false;
                    updateCanvas();
                }
            }
        };
        return new RetClass();
    })($scope);

    /** ******************** 裁剪end **********************/

    /** ******************* 旋转begin ********************/
    $scope.rotate = (function (scope) {
        var Ret = function () {
            this.radiusItemHover = null;
            this.list = [
                {
                    name: '90°',
                    alias: 'rotate_right'
                }, {
                    name: '-90°',
                    alias: 'rotate_left'
                }, {
                    name: '翻转',
                    alias: 'rotate_horizontal'
                }, {
                    name: '翻转',
                    alias: 'rotate_vertical'
                }, {
                    name: '1°',
                    alias: 'rotate_right'
                }, {
                    name: '-1°',
                    alias: 'rotate_left'
                }
            ];
        };
        Ret.prototype = {
            operation: function (index) {
                var t = this;
                switch (index) {
                    case 0:
                        // 90
                        $editImage.cropper('rotate', 90);
                        break;
                    case 1:
                        // -90
                        $editImage.cropper('rotate', -90);
                        break;
                    case 2:
                        // 左右翻转
                        $editImage.cropper('scaleX', -scope.info.image.scaleX);
                        break;
                    case 3:
                        // 上下翻转
                        $editImage.cropper('scaleY', -scope.info.image.scaleY);
                        break;
                    case 4:
                        // 1
                        $editImage.cropper('rotate', 1);
                        break;
                    case 5:
                        // -1
                        $editImage.cropper('rotate', -1);
                        break;
                }
                scope.info.updateImageData();
            }
        };
        return new Ret();
    })($scope);

    /** ******************* 旋转end *********************/

    /** ******************* 尺寸begin *******************/
    $scope.size = (function () {
        var Size = function () {
            this.width = ''; // 图片的真实高度
            this.height = '';// 图片的真实宽度
            this.canvas = document.createElement('canvas'); // 压缩缓存画布
            this.restrain = false;// 约束比例
            this.needTtriggerApply = true; // 是否需要手动触发点击应用
            this.pre = [// 预设尺寸
                {
                    name: '100 * 100',
                    checked: false
                }, {
                    name: '190 * 44',
                    checked: false
                }, {
                    name: '450 * 250',
                    checked: false
                }, {
                    name: '480 * 270',
                    checked: false
                }, {
                    name: '640 * 320',
                    checked: false
                }
            ];
            this.isEdit = false; // 判断切到缩放tap页的时候是否编辑过，因为如果只切换到缩放页，而不手动编辑会报错
        };
        Size.prototype = {
            initWAH: function () {
                var t = this,
                    imageData = $editImage.cropper('getImageData');
                t.width = imageData.naturalWidth || 0;
                t.height = imageData.naturalHeight || 0;
                return t;
            },
            validValue: function (e, type) {

                var t = this,
                    key = e.key,
                    temp = '';

                if (!imgEditorCanvasBaseService.isNumber(key) && type == 'w') {
                    temp = t.width.split('');
                    for (let i = 0; i < temp.length; i++) {
                        if (key === temp[i]) {
                            temp.splice(i, 1);
                            break;
                        }
                    }
                    t.width = temp.join('');
                }
                if (!imgEditorCanvasBaseService.isNumber(key) && type == 'h') {
                    if (!imgEditorCanvasBaseService.isNumber(key)) {
                        temp = t.height.split('');
                        for (let i = 0; i < temp.length; i++) {
                            if (key === temp[i]) {
                                temp.splice(i, 1);
                                break;
                            }
                        }
                        t.height = temp.join('');
                    }
                }

            },
            blurWOH: function (e, type) {
                var t = this,
                    ratio = $scope.info.image.aspectRatio;
                t.isEdit = true;
                if (t.restrain && type == 'w') {
                    t.height = t.width / ratio;
                }
                if (t.restrain && type == 'h') {
                    t.width = t.height * ratio;
                }
                t.adjust(Number(t.width), Number(t.height)).then(function () {
                    t.resetPre();
                    // $scope.applyCrop();
                });
            },
            switchPre: function (index) {
                var t = this,
                    arr = [];
                t.isEdit = true;
                for (var i = 0; i < t.pre.length; i++) {
                    if (i === index && t.pre[i].checked) {t.pre[i].checked = false;}
                    if (i === index && !t.pre[i].checked) {
                        t.pre[i].checked = true;
                        arr = t.pre[i].name.split(' * ');
                        t.adjust(Number(arr[0]), Number(arr[1])).then(function () {
                            t.restrain = false;
                            t.width = Number(arr[0]);
                            t.height = Number(arr[1]);
                            // $scope.applyCrop();
                        });
                    }
                    if (i !== index) {t.pre[i].checked = false;}
                }
            },
            resetPre: function () {
                var t = this;
                for (var i = 0; i < t.pre.length; i++) {t.pre[i].checked = false;}
            },
            adjust: function (w, h) {
                var url = imageCache.activeItem,
                    t = this,
                    context = t.canvas.getContext('2d'),
                    image = new Image(),
                    p = $q.defer();

                image.onload = function (e) {
                    var canvasData = $editImage.cropper('getCanvasData');
                    t.canvas.width = w;
                    t.canvas.height = h;
                    context.drawImage(image, 0, 0, image.width, image.height, 0, 0, t.canvas.width, t.canvas.height);
                    $editImage.cropper('replace', t.canvas.toDataURL(imageType));
                    canvasData.width = Number(t.canvas.width);
                    canvasData.height = Number(t.canvas.height);
                    t.setCanvasData(t.canvas.width, t.canvas.height);
                    p.resolve(t.canvas);
                };
                image.src = url;
                return p.promise;
            },
            setCanvasData: function (w, h) {
                var containerData = $editImage.cropper('getContainerData'),
                    left = 0,
                    top = 0;

                w = Number(w);
                h = Number(h);
                left = (containerData.width - w) / 2;
                top = (containerData.height - h) / 2;
                $editImage.cropper('setCanvasData', {
                    top: top,
                    left: left,
                    width: w,
                    height: h
                });
            },
            restrainSwitch: function () {
                var t = this;
                t.restrain = !t.restrain;
                t.resetPre();
            },
            reset: function () {

                var t = this;

                t.restrain = false;
                t.resetPre();

            },
            getUrl: function () {
                return this.canvas.toDataURL(imageType);
            }
        };
        return new Size();
    })();

    /** ******************* 尺寸end *******************/

    /** ******************* 文字begin *******************/
    $scope.text = (function () {
        var Text = function () {
            this.color = '#000';
            this.font = '宋体';
            this.pixel = '24像素';
            this.italic = false; // 斜体
            this.bold = false; // 加粗
            this.underline = false;// 下划线
            this.modify = ['italic', 'bold', 'underline'];
            this.opacity = 100;
            this.textEdit = {};
            this.fonts = [
                {
                    name: '宋体',
                    alias: 'SimSun',
                    checked: true
                }, {
                    name: '黑体',
                    alias: 'SimHei',
                    checked: false
                }, {
                    name: '楷体',
                    alias: 'KaiTi',
                    checked: false
                }
            ];
            this.pixels = [
                {
                    name: '10像素',
                    checked: false,
                    number: 10
                }, {
                    name: '11像素',
                    checked: false,
                    number: 11
                }, {
                    name: '12像素',
                    checked: false,
                    number: 12
                }, {
                    name: '14像素',
                    checked: false,
                    number: 14
                }, {
                    name: '18像素',
                    checked: false,
                    number: 18
                }, {
                    name: '24像素',
                    checked: true,
                    number: 24
                }, {
                    name: '30像素',
                    checked: false,
                    number: 30
                }, {
                    name: '36像素',
                    checked: false,
                    number: 36
                }, {
                    name: '48像素',
                    checked: false,
                    number: 48
                }, {
                    name: '60像素',
                    checked: false,
                    number: 60
                }, {
                    name: '72像素',
                    checked: false,
                    number: 72
                }
            ];

        };
        Text.prototype = {
            reset: function () {

                var t = this;
                t.font = '黑体';
                t.pixel = '24像素';
                t.italic = false; // 斜体
                t.bold = false; // 加粗
                t.underline = false;// 下划线
                t.resetFontAndPixel();

            },
            validValue: function (e) {

                var t = this,
                    key = e.key;

                if (!imgEditorCanvasBaseService.isNumber(key)) {
                    var temp = t.opacity.split('');
                    for (var i = 0; i < temp.length; i++) {
                        if (key == temp[i]) {
                            temp.splice(i, 1);
                            break;
                        }
                    }
                    t.opacity = temp.join('');
                    return;
                }
                if (t.opacity > 100) {
                    t.opacity = 100;
                    return;
                }
                if (t.opacity < 0) {
                    t.opacity = 0;
                    return;
                }

            },
            getPixel: function () {
                var t = this,
                    ret = 0;
                for (var i = 0; i < t.pixels.length; i++) {
                    if (t.pixels[i].checked) {
                        ret = t.pixels[i].number;
                        break;
                    }
                }
                return ret;
            },
            getColor: function () {
                var t = this,
                    rgb = t.color.split(/(\()|(\))/)[3],
                    ret = '';

                ret = 'rgba(' + rgb + ', ' + t.opacity / 100 + ')';
                return ret;
            },
            setColor: function () {

                var t = this,
                    rgba = t.getColor();

                if (t.textEdit && t.textEdit.setColor) {t.textEdit.setColor(rgba);}

            },
            getFont: function () {
                var t = this,
                    ret = '';

                if (t.italic) {ret += 'italic ';}
                if (t.bold) {ret += 'bold ';}
                for (var i = 0; i < t.pixels.length; i++) {
                    if (t.pixels[i].checked) {
                        ret += t.pixels[i].number + 'px';
                        break;
                    }
                }
                for (var i = 0; i < t.fonts.length; i++) {
                    if (t.fonts[i].checked) {
                        ret += ' ' + t.fonts[i].alias;
                        break;
                    }
                }

                return ret;
            },
            initTextEdit: function () {
                var t = this,
                    font, pixel;

                if ($ && window.TextEdit) {
                    t.textEdit = new TextEdit({
                        parent: $('.edit-area .cropper-container .cropper-canvas')[0],
                        $canvas: $editImage
                    });
                    for (var i = 0; i < t.fonts.length; i++) {
                        if (t.fonts[i].checked) {
                            font = t.fonts[i].alias;
                            break;
                        }
                    }
                    for (var i = 0; i < t.pixels.length; i++) {
                        if (t.pixels[i].checked) {
                            pixel = t.pixels[i].number;
                            break;
                        }
                    }
                    t.textEdit.initText(font, pixel);
                }
            },
            change: function (type, index) {
                // type=font或type=pixel
                var t = this,
                    arr = t[type + 's'];

                for (var i = 0; i < arr.length; i++) {
                    if (index == i) {
                        arr[i].checked = true;
                        t[type] = arr[i].name;
                        if (type == 'font') {t.textEdit.setFamily(arr[i].alias);}
                        if (type == 'pixel') {t.textEdit.setSize(arr[i].number);}
                    } else {arr[i].checked = false;}
                }
            },
            resetFontAndPixel: function () {
                var t = this;

                t.change('font', 24);// 24px
                t.change('pixel', 'SimSun');// 黑体
            },
            changeModify: function (type) {
                // type=italic,bold,underline
                var t = this;

                t[type] = !t[type];
                if (type == 'italic') {t.textEdit.setItalic(t[type]);}
                if (type == 'bold') {t.textEdit.setBold(t[type]);}
                if (type == 'underline') {t.textEdit.setUnderLine(t[type]);}

            },
            save: function (dataURL) {

                var t = this,
                    canvas = document.createElement('canvas'),
                    context = canvas.getContext('2d'),
                    canvasData = $editImage.cropper('getCanvasData'),
                    ratioW, ratioH,
                    text = t.textEdit.getText(),
                    left = t.textEdit.getTextLeft(),
                    top = t.textEdit.getTextTop(),
                    pixel = t.getPixel(),
                    textX, textY,
                    offset = [], lineX, lineY, endLineX, endLineY,
                    image = new Image(),
                    p = $q.defer();

                image.onload = function (e) {
                    ratioW = image.width / canvasData.width;
                    ratioH = image.height / canvasData.height;
                    canvas.width = image.width;
                    canvas.height = image.height;
                    context.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
                    context.font = t.getFont();
                    context.fillStyle = t.getColor();
                    for (var i = 0; i < text.length; i++) {
                        textX = left * ratioW + 4 * ratioW;
                        textY = top * ratioH + i * pixel + 4 * ratioH + 20;
                        context.fillText(text[i], textX, textY);
                        if (t.underline) {
                            offset.push(t.textEdit.lineOffsetXAY(text[i], pixel));
                            context.beginPath();
                            context.lineWidth = '1';
                            context.strokeStyle = t.getColor();
                            lineX = textX;
                            lineY = textY + 2;
                            endLineX = lineX + offset[i].x;
                            endLineY = lineY;
                            context.moveTo(lineX, lineY);
                            context.lineTo(endLineX, endLineY);
                            context.stroke();
                        }
                    }
                    p.resolve(canvas.toDataURL(imageType));
                };
                image.src = dataURL;
                return p.promise;

            }
        };
        return new Text();
    })();
    $scope.$watch(function () {
        return {
            color: $scope.text.color,
            opacity: $scope.text.opacity
        };
    }, function (newValue, oloValue) {

        if ($scope.text.textEdit && $scope.text.textEdit.setColor) {$scope.text.setColor();}

    }, true);

    /** ******************* 文字end *******************/

    /** ******************* 品质begin *******************/
    $scope.quality = (function () {

        var Quality = function () {
            this.value = 100;
        };
        Quality.prototype = {
            use: function (url) {
                var t = this,
                    cvs = document.createElement('canvas'),
                    ctx = cvs.getContext('2d'),
                    img = new Image(),
                    dataURL = url || imageCache.activeItem,
                    p = $q.defer();

                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = function (e) {
                    var newDataURL;

                    cvs.width = img.width;
                    cvs.height = img.height;
                    ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, cvs.width, cvs.height);
                    t.adjustValue();
                    newDataURL = (t.value == 100) ? dataURL : cvs.toDataURL('image/jpeg', t.value / 100);
                    p.resolve(newDataURL);
                };
                img.src = dataURL;
                return p.promise;
            },
            adjustValue: function (e) {

                var t = this,
                    key = e ? e.key : 0;

                if (!imgEditorCanvasBaseService.isNumber(key)) {
                    var temp = t.value.split('');
                    for (var i = 0; i < temp.length; i++) {
                        if (key == temp[i]) {
                            temp.splice(i, 1);
                            break;
                        }
                    }
                    t.value = temp.join('');
                    return;
                }
                if (t.value > 100) {
                    t.value = 100;
                    return;
                }
                if (t.value < 0) {
                    t.value = 0;
                    return;
                }

            }
        };
        return new Quality();

    })();

    /** ******************* 品质end *******************/

    /** ******************* 水印begin *******************/
    $scope.watermark = (function () {

        var Watermark = function () {

            this.opacity = 100;
            this.image = {
                canvas: document.createElement('canvas'),
                // max: 100, // 水印最大缩放比例
                ratio: 25 // 水印的比率（相对于原始图像的）
            };
            this.src = ''; // 基础水印图片
            this.dataURL = '';

            this.getWatermarkFlag = false; // 后台水印
            this.watermarkList = [];
            this.selectedWaterMark = null; // 当前选中的水印

            this.locations = [
                {
                    name: 'tl',
                    checked: false
                }, {
                    name: 'tm',
                    checked: false
                }, {
                    name: 'tr',
                    checked: false
                }, {
                    name: 'ml',
                    checked: false
                }, {
                    name: 'mm',
                    checked: false
                }, {
                    name: 'mr',
                    checked: false
                }, {
                    name: 'bl',
                    checked: false
                }, {
                    name: 'bm',
                    checked: false
                }, {
                    name: 'br',
                    checked: true
                }
            ];
            this.location = this.locations[this.locations.length - 1];

        };
        Watermark.prototype = {
            init: function () {
                var t = this;

                t.getWatermarkList().then(function (data) {
                    data.map(function (item, index) {
                        t.watermarkList[index] = {
                            name: item.N,
                            url: item.V,
                            checked: false
                        };
                    });
                    t.watermarkList[0].checked = true;
                    t.selectedWaterMark = t.watermarkList[0]; // 首选第一个
                    t.src = t.selectedWaterMark.url;

                    t.resetImage();
                });
            },
            validValue: function (e) {

                var t = this,
                    key = e.key;

                if (!imgEditorCanvasBaseService.isNumber(key)) {
                    var temp = t.opacity.split('');
                    for (var i = 0; i < temp.length; i++) {
                        if (key == temp[i]) {
                            temp.splice(i, 1);
                            break;
                        }
                    }
                    t.opacity = temp.join('');
                    return;
                }
                if (t.opacity > 100) {
                    t.opacity = 100;
                    return;
                }
                if (t.opacity < 0) {
                    t.opacity = 0;
                    return;
                }

            },
            reset: function () {

                var t = this;

                t.setPosition(t.locations.length - 1);
                t.image.ratio = 25;
                t.clearCanvas();
            },

            clearCanvas: function() {

                // 清除水印
                this.image.canvas.width = 0;
                this.image.canvas.height = 0;
                $(this.image.canvas).remove();
            },

            resetImage: function () {

                var t = this;

                t.getImage().then(function () {
                    return t.urlToImage();
                }).then(function () {
                    t.preview(t.location.name);
                });

                return t;

            },

            changeWaterMark: function (index) {
                var t = this,
                    arr = t.watermarkList;

                for (var i = 0; i < arr.length; i++) {
                    if (index == i) {
                        arr[i].checked = true;
                        t.selectedWaterMark = arr[i];
                        if (arr[i].value) {
                            t.resetImage();
                        } else {
                            t.reset();
                        }

                    } else {arr[i].checked = false;}
                }
            },

            getWatermarkList: function () {

                var t = this,
                    p = $q.defer(),
                    mockData = [
                        {
                            'N': '请选择水印图片',
                            'V': ''
                        }
                    ];

                if (!$scope.status.siteId && !$scope.status.channelId && !$scope.status.productId) { // 无需请求
                    t.getWatermarkFlag = false;
                    p.resolve(mockData);
                    return p.promise;
                }
                editPictureService.getWatermarkList($scope.status.siteId, $scope.status.productId, $scope.status.mediaType).then(function (data) {
                    if (angular.isArray(data) && data.length > 0) {
                        t.getWatermarkFlag = true;
                        p.resolve(mockData.concat(data));

                    } else {
                        t.getWatermarkFlag = false;
                        p.resolve(mockData);
                    }
                }, function () {
                    t.getWatermarkFlag = false;
                    p.resolve(mockData);
                });
                return p.promise;
            },

            getImage: function () {
                // 取水印图

                var t = this,
                    p = $q.defer();

                if (!t.selectedWaterMark) {
                    // 没有水印图，很有可能没有初始化
                    p.reject();
                    return p.promise;
                }
                var url = t.selectedWaterMark.url;

                var obj = {
                    src: url,
                };

                t.image = angular.extend({}, t.image, obj);

                t.src = url;
                p.resolve();
                return p.promise;

            },
            setPosition: function (index) {

                var t = this;

                for (var i = 0; i < t.locations.length; i++) {
                    if (i == index) {
                        t.locations[i].checked = true;
                        t.location = t.locations[i];
                        t.resetImage();
                    } else {
                        t.locations[i].checked = false;
                    }
                }

            },
            urlToImage: function (url) {

                var t = this,
                    src = url || t.src,
                    img = new Image(),
                    cvs = t.image.canvas,
                    ctx = cvs.getContext('2d'),
                    $parent = $('.edit-area .cropper-container .cropper-wrap-box .cropper-canvas'),

                    cvsData = $editImage.cropper('getCanvasData'),
                    naturalWidth = cvsData.naturalWidth,
                    naturalHeight = cvsData.naturalHeight,
                    cvsWidth = cvsData.width,
                    cvsHeight = cvsData.height,

                    p = $q.defer();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = function (e) {

                    t.image.width = cvs.width = cvsWidth * t.image.ratio / 100;
                    t.image.height = cvs.height = cvs.width / (img.width / img.height);
                    t.image.naturalWidth = img.width;
                    t.image.naturalHeight = img.height;

                    ctx.globalAlpha = t.opacity / 100;
                    ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, cvs.width, cvs.height);
                    t.dataURL = cvs.toDataURL(imageType);
                    p.resolve();

                };
                $parent.append($(cvs));
                img.src = src;
                return p.promise;

            },
            preview: function (type) {

                var t = this,
                    cvsData = $editImage.cropper('getCanvasData'),
                    cvsWidth = cvsData.width,
                    cvsHeight = cvsData.height,
                    $canvas = $(t.image.canvas),
                    imgWidth = t.image.width,
                    imgHeight = t.image.height,
                    top = 10,
                    left = 10;

                type = type || t.location.name;
                switch (type) {
                    case 'tl':
                        // 上左
                        break;
                    case 'tm':
                        // 上中
                        left = cvsWidth / 2 - imgWidth / 2;
                        break;
                    case 'tr':
                        // 上右
                        left = cvsWidth - imgWidth - 10;
                        break;
                    case 'ml':
                        // 中左
                        top = cvsHeight / 2 - imgHeight / 2;
                        break;
                    case 'mm':
                        // 中中
                        left = cvsWidth / 2 - imgWidth / 2;
                        top = cvsHeight / 2 - imgHeight / 2;
                        break;
                    case 'mr':
                        // 中右
                        left = cvsWidth - imgWidth - 10;
                        top = cvsHeight / 2 - imgHeight / 2;
                        break;
                    case 'bl':
                        // 下左
                        top = cvsHeight - imgHeight - 10;
                        break;
                    case 'bm':
                        // 下中
                        left = cvsWidth / 2 - imgWidth / 2;
                        top = cvsHeight - imgHeight - 10;
                        break;
                    case 'br':
                        // 下右
                        left = cvsWidth - imgWidth - 10;
                        top = cvsHeight - imgHeight - 10;
                        break;
                }
                $canvas.css({
                    display: 'block',
                    position: 'absolute',
                    left: left + 'px',
                    top: top + 'px'
                });

            },
            apply: function (dataURL) {

                var t = this,
                    type = t.location.name,
                    x = 10, y = 10,
                    cvs = document.createElement('canvas'),
                    ctx = cvs.getContext('2d'),
                    img = new Image(),
                    wmImg = new Image(),
                    p = $q.defer();

                dataURL = dataURL || imageCache.activeItem;
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = function () {

                    cvs.width = img.width;
                    cvs.height = img.height;
                    ctx.globalAlpha = 1;
                    ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, cvs.width, cvs.height);
                    wmImg.src = t.src;

                };
                wmImg.setAttribute('crossOrigin', 'anonymous');
                wmImg.onload = function () {

                    var width = img.width * t.image.ratio / 100,
                        height = width / (wmImg.width / wmImg.height);

                    switch (type) {
                        case 'tl':
                            // 上左
                            break;
                        case 'tm':
                            // 上中
                            x = img.width / 2 - width / 2;
                            break;
                        case 'tr':
                            // 上右
                            x = img.width - width - 10;
                            break;
                        case 'ml':
                            // 中左
                            y = img.height / 2 - height / 2;
                            break;
                        case 'mm':
                            // 中中
                            x = img.width / 2 - width / 2;
                            y = img.height / 2 - height / 2;
                            break;
                        case 'mr':
                            // 中右
                            x = img.width - width - 10;
                            y = img.height / 2 - height / 2;
                            break;
                        case 'bl':
                            // 下左
                            y = img.height - height - 10;
                            break;
                        case 'bm':
                            // 下中
                            x = img.width / 2 - width / 2;
                            y = img.height - height - 10;
                            break;
                        case 'br':
                            // 下右
                            x = img.width - width - 10;
                            y = img.height - height - 10;
                            break;
                    }
                    ctx.globalAlpha = t.opacity / 100;
                    ctx.drawImage(wmImg, 0, 0, wmImg.width, wmImg.height, x, y, width, height);
                    p.resolve(cvs.toDataURL(imageType));

                };
                img.src = dataURL;

                return p.promise;

            }

        };
        return new Watermark();

    })();

    // 监听水印透明度的变化
    $scope.$watch(function () {
        return {
            opacity: $scope.watermark.opacity,
            ratio: $scope.watermark.image.ratio
        };
    }, function (newValue, oldValue) {

        if (newValue.opacity != oldValue.opacity || newValue.ratio != oldValue.ratio) {
            $scope.watermark.resetImage();
        }

    }, true);

    /** ******************* 水印end *******************/

    /** ******************* 涂鸦begin *******************/
    $scope.scrawl = (function () {

        var Scrawl = function () {

            this.color = '#000'; // 涂鸦默认的颜色
            this.isBrush = true;
            this.paint = {};
            this.list = [
                {
                    size: 2,
                    checked: true,
                    style: 'width: 2px;height: 2px; border-radius: 2px;',
                    pixel: '2px'
                }, {
                    size: 4,
                    checked: false,
                    style: 'width: 4px;height: 4px; border-radius: 4px;',
                    pixel: '4px'
                }, {
                    size: 6,
                    checked: false,
                    style: 'width: 6px;height: 6px; border-radius: 6px;',
                    pixel: '6px'
                }, {
                    size: 8,
                    checked: false,
                    style: 'width: 8px;height: 8px; border-radius: 8px;',
                    pixel: '8x'
                }, {
                    size: 10,
                    checked: false,
                    style: 'width: 10px;height: 10px; border-radius: 10px;',
                    pixel: '10px'
                }
            ];

        };
        Scrawl.prototype = {
            reset: function () {

                var t = this;

                t.setActive(0);

            },
            init: function () {

                var t = this;
                t.paint = new Paint({
                    parent: $('.edit-area .cropper-container .cropper-wrap-box .cropper-canvas')[0]
                });
                t.paint.color = t.color; // 这里给画笔设置颜色
                t.setBrush();

            },
            setActive: function (index) {

                var t = this;

                for (var i = 0; i < t.list.length; i++) {
                    if (i == index) {
                        t.list[i].checked = true;
                        t.paint.lineWidth = t.list[i].size;
                        t.setBrush();
                    } else {
                        t.list[i].checked = false;
                    }
                }

            },
            getBrushSize: function () {

                var t = this;

                for (var i = 0; i < t.list.length; i++) {
                    if (t.list[i].checked) {return t.list[i].size;}
                }

            },
            createBrushImage: function () {

                var t = this,
                    dia = t.getBrushSize(), // 直径
                    cvs = document.createElement('canvas'),
                    ctx = cvs.getContext('2d');

                cvs.width = cvs.height = dia;
                ctx.beginPath();
                ctx.arc(dia / 2, dia / 2, dia / 2, 0, 2 * Math.PI);
                ctx.stroke();

                return cvs.toDataURL(imageType);

            },
            setBrush: function () {

                var t = this,
                    brushDataURL = t.createBrushImage(),
                    cvs = t.paint.canvas;

                $('#' + t.paint.canvasId).css('cursor', 'url(' + brushDataURL + '),auto');

            },
            save: function (dataURL) {

                var t = this,
                    imgDataURL = dataURL || imageCache.activeItem,
                    scrawlDataURL = t.paint.getDataURL(),
                    img = new Image(),
                    scrawlImg = new Image(),
                    cvs = document.createElement('canvas'),
                    cxt = cvs.getContext('2d'),
                    p = $q.defer();

                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = function () {

                    cvs.width = img.width;
                    cvs.height = img.height;
                    cxt.drawImage(img, 0, 0, img.width, img.height, 0, 0, cvs.width, cvs.height);
                    scrawlImg.src = scrawlDataURL;

                };
                scrawlImg.setAttribute('crossOrigin', 'anonymous');
                scrawlImg.onload = function () {

                    cxt.drawImage(scrawlImg, 0, 0, scrawlImg.width, scrawlImg.height, 0, 0, cvs.width, cvs.height);
                    p.resolve(cvs.toDataURL(imageType));

                };
                img.src = imgDataURL;

                return p.promise;

            }
        };
        return new Scrawl();

    })();


    $scope.$watch(function () {
        return {
            color: $scope.scrawl.color,
        };
    }, function (newValue, oloValue) {
        if ($scope.scrawl.paint && $scope.scrawl.paint.setPaintColor) {
            $scope.scrawl.paint.color = newValue.color;
            $scope.scrawl.paint.setPaintColor();
        }
    }, true);

    /*
     功能：涂鸦画板
     依赖： $, $editImage, imgEditorCanvasBaseService
     参数：
     option.parent：画板容器
     */
    var Paint = (function () {

        var Paint = function (option) {

            var self = this;

            self.canvas = document.createElement('canvas');
            self.canvasId = 'canvas_' + new Date().getTime();
            self.canvas.id = self.canvasId;
            self.canvas.self = self;
            self.lineWidth = 2;
            self.parent = option && option.parent || $('body');
            self.init();

        };
        Paint.prototype = {
            init: function () {

                var t = this,
                    parent = t.parent,
                    cvs = t.canvas;
                // t.color = '#000';        // 这里由watch中传值
                t.setCanvas();
                cvs._fnStart = imgEditorCanvasBaseService.BindAsEventListener(cvs, t.start);
                cvs._fnMove = imgEditorCanvasBaseService.BindAsEventListener(cvs, t.move);
                cvs._fnStop = imgEditorCanvasBaseService.Bind(cvs, t.stop);
                cvs._x = 0;// 鼠标在画布上的x坐标，以画布左上角为起点
                cvs._y = 0;// 鼠标在画布上的y坐标，以画布左上角为起点
                cvs.old = {};// 鼠标在画布上的上个点
                imgEditorCanvasBaseService.addEventHandler(cvs, 'mousedown', cvs._fnStart);
                $(parent).append($(cvs));
                $(cvs).css({
                    'position': 'absolute',
                    'top': '0',
                    'left': '0',
                    'z-index': '15'
                });

            },
            setCanvas: function () {

                var t = this,
                    cvs = t.canvas,
                    cxt = cvs.getContext('2d'),
                    canvasData = $editImage.cropper('getCanvasData');

                cvs.width = canvasData.width;
                cvs.height = canvasData.height;
                cxt.globalAlpha = 0;
                cxt.beginPath();
                cxt.rect(0, 0, cvs.width, cvs.height);
                cxt.fill();
            },
            cleanPaint: function () {
                var t = this;

                t.setCanvas();

                if ($scope.scrawl.color) {
                    t.color = angular.copy($scope.scrawl.color);
                    t.setPaintColor();
                }
            },
            getColor: function () {
                var t = this,
                    rgba = t.color.split(/(\()|(\))/)[3],
                    ret = '';

                ret = 'rgba(' + rgba + ')';
                return ret;
            },

            setPaintColor: function () {
                var t = this,
                    cvs = t.canvas,
                    cxt = cvs.getContext('2d');
                cxt.strokeStyle = t.getColor(); // 最后改这里
            },

            scrawl: function (current) {

                // current: 鼠标在画布上的坐标
                var t = this,
                    cvs = t.canvas,
                    cxt = cvs.getContext('2d'),
                    old = cvs.old;// 鼠标在画布上的上一个坐标

                cxt.beginPath();
                cxt.globalAlpha = 1;
                // cxt.strokeStyle = 'red';  // 更改成动态设置
                cxt.lineWidth = t.lineWidth;
                cxt.lineJoin = 'round';
                cxt.moveTo(old.x, old.y);
                cxt.lineTo(current.x, current.y);
                cxt.closePath();
                cxt.stroke();
                cvs.old = current;
            },
            getPoint: function (e) {

                var t = this,
                    cvs = t.canvas;

                return {
                    x: e.clientX - cvs._x,
                    y: e.clientY - cvs._y
                };

            },
            getDataURL: function () {

                var t = this,
                    cvs = t.canvas;

                return cvs.toDataURL('image/png');

            },
            start: function (e) {

                var cvs = this,
                    self = cvs.self,
                    p = imgEditorCanvasBaseService.getNodePosition(cvs);

                cvs._x = p.left;
                cvs._y = p.top;
                cvs.old = self.getPoint(e);
                imgEditorCanvasBaseService.addEventHandler(cvs, 'mousemove', cvs._fnMove);
                imgEditorCanvasBaseService.addEventHandler(document, 'mouseup', cvs._fnStop);

            },
            move: function (e) {

                var cvs = this,
                    self = cvs.self,
                    current = self.getPoint(e);// 当前鼠标在画布上的坐标

                self.scrawl(current);

            },
            stop: function () {

                var cvs = this;

                imgEditorCanvasBaseService.removeEventHandler(cvs, 'mousemove', cvs._fnMove);
                imgEditorCanvasBaseService.removeEventHandler(document, 'mouseup', cvs._fnStop);

            }
        };
        return Paint;

    })();

    /** ******************* 涂鸦end *******************/

    /** ******************** 画布begin **********************/
    // 创建编辑区域，初始化画布
    $scope.$watch('imgOpen', function (newValue, oldValue) {
        var options = {}, imageSuffix;

        if (newValue && newValue != oldValue) {
            $scope.showLoading = true;

            if ($scope.imgUrl) {
                imageSuffix = $scope.imgUrl.split('.').reverse()[0]; // 这里获取图片格式
                if (imageSuffix && imageSuffix.toLocaleLowerCase() === 'png') {
                    imageType = 'image/png';
                } else {
                    imageType = 'image/jpeg';
                }
            }
            $editImage = $element.find('#edit_image');// 更新图片对象
            if ($scope.watermark.image.canvas) {$($scope.watermark.image.canvas).remove();}
            if ($scope.cropperOption) {DEFAULT = angular.extend(DEFAULT, $scope.cropperOption);}
            $editImage[0].setAttribute('crossOrigin', 'anonymous');
            $editImage.one('load', function (e) {
                var img = e.target,
                    width = e.target.width,
                    height = e.target.height;
                options = angular.extend({}, DEFAULT, {
                    modal: true,
                    built: function () { // 初始化 cropper 成功，并拿到 img data 数据
                        var cvs = document.createElement('canvas'),
                            cxt = cvs.getContext('2d'),
                            imageData = $editImage.cropper('getImageData');
                        cvs.width = imageData.naturalWidth;
                        cvs.height = imageData.naturalHeight;
                        cxt.drawImage(img, 0, 0, width, height, 0, 0, cvs.width, cvs.height);
                        imageCache.push(cvs.toDataURL(imageType));

                        $scope.$apply(function () {
                            $scope.info.setImageSize();
                            // updateCanvas();
                            if ($scope.cropperOption.size) { // 如果传入进来预设比例，则默认选中
                                $scope.preScale.switch(0);
                            } else {
                                updateCanvas();
                            }
                            $scope.showLoading = false;
                        });
                        deleteContainer();
                    },
                    error: function () { // 初始化 cropper 失败

                        modalDialog.alertType('', '图片编辑器初始化失败,请关闭弹窗后重试', 'warning', false);

                        $scope.showLoading = false;
                    }
                });
                $editImage.cropper('destroy').cropper(options);
            }).one('error', function (e) {
                $scope.showLoading = false;

                modalDialog.alertType('', '图片加载失败,请关闭弹窗后重试', 'warning', false);

            });

            var getTimestamp = new Date().getTime();
            var url = $scope.imgUrl + '';
            if (url.indexOf('?') > -1) {
                url = url + '&t=' + getTimestamp;
            } else {
                url = url + '?t=' + getTimestamp;
            }
            $editImage.attr('src', url);
        }

    });

    // 画布信息
    $scope.info = (function (scope) {

        var Info = function () {

            var self = this;

            // 图片信息
            self.image = {};
            // 裁剪框信息
            self.cropBox = {};
            // 图片尺寸，b
            self.imageSize = 0;
            // 是否是正在保存
            self.saved = false;

        };
        Info.prototype = {
            setCropBoxData: function (data) {
                var t = this;
                $editImage.cropper('setCropBoxData', data);
                t.updateCropBoxData();
            },
            updateCropBoxData: function () {
                var data = $element.find('#edit_image').cropper('getCropBoxData'),
                    t = this;
                for (var item in data) {t.cropBox[item] = data[item];}
            },
            updateImageData: function () {
                var data = $element.find('#edit_image').cropper('getImageData'),
                    t = this;
                for (var item in data) {t.image[item] = data[item];}
            },
            updateMore: function (options) {
                var t = this;
                if (options && options.image) {t.updateImageData();}
                if (options && options.cropBox) {t.updateCropBoxData();}
            },
            setImageSize: function () {
                var t = this,
                    url = imageCache.activeItem,
                    blob = imgEditorCanvasBaseService.dataURLtoBlob(url);

                t.imageSize = blob && blob.size && Math.floor(blob.size / 1024);
            },

            /**
             * [close description]关闭图片编辑器
             *
             * @return  {[type]}   [return description]
             */
            close: function () {

                // 裁剪
                $scope.restrainScale.reset();
                $scope.preScale.reset();
                $scope.customScale.clear();

                // 尺寸
                $scope.size.reset();

                // 文字
                $scope.text.reset();

                // 水印
                $scope.watermark.reset();

                // 涂鸦
                $scope.scrawl.reset();

                // 导航
                $scope.nav.reset();

                // 缓存
                imageCache.clear();

                extendOptions = {
                    toggleDragModeOnDblclick: true,
                    autoCrop: true,
                    dragMode: 'crop',
                    built: function () {

                        $scope.applying = false;
                        $scope.info.setImageSize();
                        updateCanvas();
                        safeApply();

                    }
                };
                $scope.applying = false;
                $('.cropper-container').remove();

                $scope.imgOpen = false;

                // 关闭弹窗
                $modalInstance.dismiss();

            },

            /*
             功能： 保存图片到后台
             */
            save: function () {
                var t = this,
                    dataURL = imageCache.activeItem,
                    imageData = $editImage.cropper('getImageData');
                if ($scope.cropperOption.size) { // 如果有系统预设比例，则要在点击保存时进行判断
                    const preSizeArr = $scope.cropperOption.size.split(',');
                    const preSize = Number((preSizeArr[0] / preSizeArr[1]).toFixed(2));
                    const imgAspectRatio = Number(imageData.aspectRatio.toFixed(2));
                    if (preSize - 0.1 > imgAspectRatio || preSize + 0.1 < imgAspectRatio) {
                        modalDialog.alertType('当前图片比例与预设比例不符，请重新裁剪', '', 'info', false);
                        return;
                    }
                }
                if ($scope.applying) {return;}
                t.saved = true;

                var data = {
                    url: dataURL,
                    ratio: imageData.aspectRatio,
                    width: imageData.naturalWidth,
                    height: imageData.naturalHeight
                };

                var databaseUrl = data.url;
                $scope.loadingPromise = editPictureService.submitDatabase64Url(databaseUrl).then(function (res) {
                    t.saved = false;

                    // var url = "/wcm/app/system/read_image.jsp?FileName=" + res.imgName;
                    res.imgSrc = '/wcm/file/read_image.jsp?FileName=' + res.imgName;
                    // stateOriginalPic(url);

                    $modalInstance.close(res);
                }, function () {
                    t.saved = false;
                    modalDialog.alertType('保存失败', '', 'error', false);

                    // 保存失败
                });
            },
            confirm: function() {
                $scope.applyCrop(() => {
                    $timeout(() => {
                        this.save();
                    });
                });
            }
        };

        return new Info();

    })($scope);

    /*
     功能：缩放图片
     参数：
     type：in放大，out缩小
     */
    $scope.zoom = function (type) {

        var zoom;

        if (type == 'in') {zoom = 0.1;}
        if (type == 'out') {zoom = -0.1;}
        $editImage.cropper('zoom', zoom);

    };

    /**
     * [updateCanvas description]功能：更新画布相关信息
     *
     * @param  {[type]}  option   [option description]
     *
     * @return  {[type]}   [return description]
     */
    function updateCanvas(option) {

        $scope.info.updateMore({
            image: true,
            cropBox: true
        });
        $scope.crop.updateWAH();

    }

    /** ******************** 画布end **********************/

    /**
     * [deleteContainer description]删除多余编辑图片容器
     *
     * @return  {[type]}   [return description]
     */
    function deleteContainer() {
        $('.cropper-container').each(function (index, item) {
            if (index > 0) {
                item.remove();
            }
        });
    }

    /**
     * [safeApply description]安全脏循环检测
     *
     * @return  {[type]}   [return description]
     */
    function safeApply() {
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    /**
     * [stateOriginalPic description]建立原图和改后图的关联
     *
     * @param  {[type]}  newPicUrl   [newPicUrl description]
     *
     * @return  {[type]}   [return description]
     */
    function stateOriginalPic(newPicUrl) {
        var params = {
            serviceid: 'mlf_picrecover',
            methodname: 'savePicsRel',
            NewPicName: editPictureService.getFileName(newPicUrl),
            OriginalPic: editPictureService.getFileName($scope.status.APPFILE),
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
            console.log(data);
        });
    }

    // 手动触发加载
    $timeout(function () {
        $scope.imgOpen = true;
    }, 0);

}]);
